module.exports = __webpack_public_path__ + "img/c06_unitscout_Normal_ua.eac8b22b.webp";